import React, {Component} from "react";
import settingStorage from "../util/setting-storage";
import ConstantSetting from "../RealTimeMonitor/modules/v2/ConstantSetting";
import {Button, Col, Form, Input, message, Row, Switch} from "antd";
import FormItem from "antd/es/form/FormItem";
import {baseUrl} from "../../UrlConfig";

/**
 * @name: venueSetting
 * @author: Seeker
 * @date: 2022-10-31 11:08
 * @description：venueSetting
 * @update: 2022-10-31 11:08
 */

export default class ViewMqttConnectState extends Component{

    constructor(props) {
        super(props);
    }

    save = (values) => {
        const {venuePassword} = values
        if (venuePassword === 'zxyl2016'){
            this.props.hideFun();
            window.open(`${baseUrl}/admin/main/mqttTest`,'mqttTest')
        }else {
            message.error('授权密码输入错误').then(r => {})
        }
    }

    render() {
        return (
            <Form onFinish={this.save}>
                <Row>
                    <Col span={24} className={'setting-row-size2-slider'}>
                        <FormItem
                            {...ConstantSetting.selectFormItemLayout3}
                            label='授权密码'
                            name={'venuePassword'}
                            rules={[{required: true, message: '请输入授权密码'}]}
                        >
                            <Input type={'password'} placeholder={'请输入授权密码'} />
                        </FormItem>
                    </Col>
                </Row>

                <FormItem style={{textAlign: 'right', margin: '20px 20px 10px 0px'}}>
                    <Button onClick={this.props.hideFun} style={{marginRight: '20px'}}>取消</Button>
                    <Button type="primary" htmlType={'submit'}>确定</Button>
                </FormItem>

            </Form>
        )
    }

}
